const TWO_DIGIT_YEAR_PIVOT = 50;

function validDate(year, month, day) {
  if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) return null;
  if (year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1 || day > 31) return null;
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
}

export function sanitizeVestaDateEntry(value) {
  return String(value || "").replace(/\D/g, "").slice(0, 8);
}

export function parseVestaDate(value) {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return validDate(value.getFullYear(), value.getMonth() + 1, value.getDate());
  }

  const raw = String(value || "").trim();
  if (!raw) return null;

  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
  if (iso) return validDate(Number(iso[1]), Number(iso[2]), Number(iso[3]));

  const digits = raw.replace(/\D/g, "");
  if (digits.length !== 6 && digits.length !== 8) return null;

  const day = Number(digits.slice(0, 2));
  const month = Number(digits.slice(2, 4));
  const rawYear = digits.length === 6 ? Number(digits.slice(4, 6)) : Number(digits.slice(4, 8));
  const year = digits.length === 6
    ? (rawYear < TWO_DIGIT_YEAR_PIVOT ? 2000 + rawYear : 1900 + rawYear)
    : rawYear;

  return validDate(year, month, day);
}

export function formatVestaDate(value) {
  const date = parseVestaDate(value);
  if (!date) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}/${date.getFullYear()}`;
}

export function normalizeVestaDateInput(value) {
  return formatVestaDate(value);
}

export function toIsoVestaDate(value) {
  const date = parseVestaDate(value);
  if (!date) return "";
  const year = String(date.getFullYear()).padStart(4, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
